import { render } from "./AllWorkspacesPage.vue?vue&type=template&id=edb5bf46&scoped=true"
import script from "./AllWorkspacesPage.vue?vue&type=script&lang=js"
export * from "./AllWorkspacesPage.vue?vue&type=script&lang=js"

import "./AllWorkspacesPage.vue?vue&type=style&index=0&id=edb5bf46&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edb5bf46"]])

export default __exports__